import loadable from '@loadable/component'
import { appPrefix } from 'utils/browserHelper'

const Home = loadable(() => import(/* webpackChunkName: "HotelsHome" */ 'pages/hotels/home'))
const Result = loadable(() => import(/* webpackChunkName: "HotelsHome" */ 'pages/hotels/results'))
const MerchResult = loadable(() => import(/* webpackChunkName: "HotelsHome" */ 'pages/hotels/results'))
const DetailsPage = loadable(() => import(/* webpackChunkName: "HotelsHome" */ 'pages/hotels/details'))
const ConfrimationPage = loadable(() => import(/* webpackChunkName: "HotelsHome" */ 'pages/hotels/confirmation'))
const PaymentFailed = loadable(() => import(/* webpackChunkName: "HotelsHome" */ 'pages/hotels/Error/PaymentFailed'))
const BookingFailed = loadable(() => import(/* webpackChunkName: "HotelsHome" */ 'pages/hotels/Error/BookingFailed'))
const ItineraryLoading = loadable(() =>
    import(/* webpackChunkName: "HotelsHome" */ 'components/details/ItineraryLoading')
)

const ItineraryFailure = loadable(() =>
    import(/* webpackChunkName: "HotelsHome" */ 'components/details/ItineraryFailure')
)

const ItineraryPage = loadable(() => import(/* webpackChunkName: "HotelsHome" */ 'pages/hotels/itinerary'))

export default [
    {
        path: `${appPrefix}/`,
        component: Home,
        exact: true
    },
    {
        path: `${appPrefix}/hotels`,
        component: Home,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/results`,
        component: Result,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/merchresults`,
        component: MerchResult,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/details/:details`,
        component: DetailsPage,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/details/itinerary/loading`,
        component: ItineraryLoading,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/details/itinerary/failure`,
        component: ItineraryFailure,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/itinerary/:id/info`,
        component: ItineraryPage,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/itinerary/:id/confirmation`,
        component: ConfrimationPage,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/itinerary/:id/payment-failed`,
        component: PaymentFailed,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/itinerary/:id/booking-failed`,
        component: BookingFailed,
        exact: true
    },
    {
        path: `${appPrefix}/hotels/itinerary/:id/review`,
        component: ItineraryPage,
        exact: true
    }
]
